// src/components/DashboardCard.js
import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const DashboardCard = ({ title, icon, children, action }) => {
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {icon && (
              <Box
                sx={{
                  color: "primary.main",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {icon}
              </Box>
            )}
            <Typography variant="h6" component="h2" fontWeight={600}>
              {title}
            </Typography>
          </Box>
          {action && <Box>{action}</Box>}
        </Box>
        {children}
      </CardContent>
    </Card>
  );
};

export default DashboardCard;
